<template>
    <popup ref="popup" :show.sync="openPop" :showClose="false" :hideTitle="true">
        <van-datetime-picker
            type="date"
            title="请选择日期"
            @confirm='confirm'
            @cancel="cancel"
            :min-date="minDate"
            :max-date="maxDate"
            v-model="currentDate"

        />
    </popup>
  </template>

<script>
import Popup from '@/components/Popup';
import 'vant/lib/datetime-picker/style';
export default {
  components: {
    Popup,
  },
  data() {
    return {
      openPop: false,
      pickerIdx: -1,
      minDate: new Date(-2209017943000), // 最小时间，1900年
      maxDate: new Date(4828176000000), // 最大时间，2123年
      currentDate: new Date(),
    };
  },
  methods: {
    confirm(val) {
      this.$emit('pickedDateTimeChange', {
        val,
        pickerIdx: this.pickerIdx,
      });
      this.hide();
    },
    cancel() {
      this.$emit('cancel');
      this.hide();
    },
    show(pickerIdx) {
      setTimeout(() => {
        this.openPop = true;
      }, 400);
      this.pickerIdx = pickerIdx;
    },
    hide() {
      this.openPop = false;
      this.pickerIdx = -1;
    },
  },
};
</script>

  <style lang="less" scoped>
  </style>

